import styled, { css } from 'styled-components';
import { FONT_COLOURS, FONT_WEIGHT, getBodyFont } from '@belong/themes';
import { MaybeStyledCSS } from '@belong/types';
import { Text } from '../Text';
import { ICopy } from './Copy.types';

/**
 * Callers must omit attrs-backed props to use these defaults; explicitly passing `undefined` resets them.
 */
export const Copy = styled(Text).attrs<ICopy>(props => ({
  hasColor: props.hasColor,
  variant: props.variant || 'medium',
  as: props.as || 'p'
}))<ICopy>`
  ${({ isBold, hasColor }): MaybeStyledCSS => {
    const bold = css`
      font-weight: ${FONT_WEIGHT.SEMI_BOLD};
      color: ${hasColor === FONT_COLOURS.BASE && FONT_COLOURS.STRONG};
    `;

    return isBold
      ? bold
      : css`
          font-weight: ${FONT_WEIGHT.REGULAR};
          > strong {
            ${bold}
          }
        `;
  }}

  ${({ hasColor, theme }) =>
    !hasColor &&
    css`
      color: ${theme.foregroundColor};
      > strong {
        color: ${theme.foregroundColor};
      }
    `}

  ${({ variant }) => variant && getBodyFont(variant)}

  ${({ variant, hasColor, theme }) =>
    variant === 'small' &&
    !hasColor &&
    css`
      &,
      & > strong {
        color: ${theme.foregroundColorLight};
      }
    `}
`;

Copy.displayName = 'Copy';
